var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.49 34.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #d2bb77;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,13.9l-6.19-10.73c-1.14-1.97-3.24-3.18-5.51-3.18h-12.38c-2.27,0-4.37,1.21-5.51,3.18L.85,13.9c-1.14,1.97-1.14,4.39,0,6.36l6.19,10.73c1.14,1.97,3.24,3.18,5.51,3.18h12.38c2.27,0,4.37-1.21,5.51-3.18l6.19-10.73c1.14-1.97,1.14-4.39,0-6.36ZM14.44,25.28c-.09,0-.16.01-.22.01-1.06,0-2.11,0-3.17,0-.2,0-.25-.05-.25-.25,0-3.74,0-7.49,0-11.23,0-.07,0-.14,0-.23h3.64v11.7ZM12.6,11.96c-1.17,0-2.12-.98-2.1-2.14.02-1.16.98-2.1,2.14-2.08,1.18.01,2.11.96,2.1,2.14-.01,1.16-.97,2.09-2.13,2.09ZM28.1,25.07c0,.06,0,.12-.01.2h-3.63c0-.1,0-.2,0-.3,0-1.96.01-3.93-.02-5.89,0-.51-.09-1.04-.24-1.53-.19-.67-.71-1-1.39-1.06-.18-.01-.36-.01-.54,0-.86.07-1.46.52-1.68,1.36-.13.51-.19,1.04-.2,1.56-.02,1.86,0,3.72,0,5.59v.27h-3.63v-11.7h3.47v1.56c.06-.05.09-.06.1-.08.8-1.24,1.98-1.78,3.42-1.79.8,0,1.57.1,2.3.47.91.45,1.42,1.22,1.71,2.16.26.85.34,1.72.34,2.6,0,2.19,0,4.39,0,6.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.f8527dccf53a900529eeb9cdab38c4bf.svg";
export { ForwardRef as ReactComponent };